import { MenuItemsType } from '../types/menuTypes';

export const getActiveMenuItems = (menuItems: MenuItemsType) =>
  menuItems.filter((e) => !e.hide);

export const getMenuItemsVisibleOnDashboard = (menuItems: MenuItemsType) =>
  menuItems.filter(
    (e) => e.visibleOnDashboard || e.visibleOnDashboard === undefined
  );
